import React from 'react';
import classes from './ScrollDown.module.css';

const ScrollDown = ({ link }) => {
  return (
    <>
      <div className={classes['scroll-down']}>
        <a href={link}>
          <span className={classes['scroll-span']}></span>
          <span className={classes['scroll-span']}></span>
          <span className={classes['scroll-span']}></span>
        </a>
      </div>
    </>
  );
};

export default ScrollDown;
